import React, { useRef } from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { EntryDrawer } from './entry-drawer'

// An entry's permalink (entryPath: /org|/admin/audit-log/entry/:entryID), so
// "Copy link" resolves: the entry in its drawer. It is NOT gated on
// /capabilities: anyone signed in who opens a copied link gets the drawer,
// getEntry runs, and the API decides (a refusal shows in the drawer). A
// record editor who copied a link from History without the audit log can
// still open it. The super admin's link reads across organizations
// (scope=all).
//
// The Audit log page renders under it (AuditLogRoute) when the reader may
// see the list. Closing goes back when the app navigated here (from the list
// or from a record page); a link opened on its own (a pasted link, a new tab)
// closes to the list with its query string when the reader may see it
// (listAllowed), else to `home`.
//
// How the entry was reached is decided once, when it first shows: the app
// marks its own navigations (ENTRY_STATE), and any PUSH counts too (a <Link>
// on a record page). It is never read from history.action at close time: the
// grids under the drawer rewrite the URL with replace (their sort and
// search), which changes history.action and drops location.state.
export const ENTRY_STATE = { auditFromApp: true }

export const AuditEntryRoute = ({ base, sys = false, home, listAllowed = false }) => {
  const m = useRouteMatch(`${base}/entry/:entryID`)
  const history = useHistory()
  const location = useLocation()
  const seen = useRef({ id: null, fromApp: false })
  const entryID = m ? m.params.entryID : null
  if (!entryID) seen.current = { id: null, fromApp: false }
  else if (seen.current.id !== entryID) {
    seen.current = { id: entryID, fromApp: history.action === 'PUSH' || Boolean(location.state && location.state.auditFromApp) }
  }
  if (!m) return null
  const close = () => {
    if (seen.current.fromApp) history.goBack()
    else if (listAllowed) history.replace({ pathname: base, search: location.search })
    else history.push(home)
  }
  return <EntryDrawer sys={sys} entryID={m.params.entryID} onClose={close} />
}
